// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/login-drop.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/Mask Group 16@2x.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signup {
    background-color: #ffffff;
    position: relative;
    height: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: -120px 20px;
    background-size: 400px;
    position: relative;
}

.signup .container {
    max-width: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
    background-size: cover;
    text-align: center;
    padding: 30px 100px;
}

.signup-header h1 {
    font-size: 20px;
    color: #2A2F5C;
    font-weight: 600;
}

.signup .home {
    position: absolute;
    top: 30px;
    left: 20px;
    border-bottom: 2px solid #060D27;
}

.signup .home a{
    color: #060D27;
    text-decoration: none;
}

.signup-section {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ffffff;
    box-shadow: 0px 20px 50px #00000029;
    border-radius: 20px;
    padding: 20px 0px 0px 0px;
}

.signup .form-data {
    width: 600px;
}

.signup .form-label {
    text-align: left;
    color: #5E6C9A;
    font-weight: 600;
}

.signup .form-control {
    background-color: transparent;
    border: 1px solid #3E6BFF;
    border-radius: 8px;
    color: #A0A0A0;
    box-shadow: none;
}

.signup .error {
    border: 1px solid #E86880;
}

.signup .form h2{
    letter-spacing: 0px;
    color: #3C68F8;
    font-size: 22px;
}

.signup .form p{
    font-size: 14px;
    letter-spacing: 0px;
    color: #A0A0A0;
}

.signup .form a {
    text-decoration: none;
    color: #3C68F8;
    font-weight: 100;
}

.signup .form span a {
    color: #060D27;
    font-weight: 600;
}

.signup small {
    color: #E86880;
}

.signup .btn {
    background-color: #060D27;
    margin-top: 20px;
    color: #ffffff;
    font-weight: 600;
    border-radius: 30px;
    width: 50%;
    height: 45px;
    margin-bottom: 20px;
}

.signup .welcome-vid {
    position: absolute;
    z-index: 0;
    top: 0;
    right: 150px;
    margin-top: 5px;
}

.signup .welcome-vid video{
    height: 300px;
}

.signup .form-data .password {
    position: relative;
}

.signup .form-data .password img {
    position: absolute;
    top: 42px;
    right: 10px;
    height: 12px;
    margin-right: 15px;
    cursor: pointer;
}

.signup .password input {
    letter-spacing: 5px;
}`, "",{"version":3,"sources":["webpack://./src/view/entrance/Signup.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,yDAA2D;IAC3D,4BAA4B;IAC5B,gCAAgC;IAChC,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,yDAAmE;IACnE,4BAA4B;IAC5B,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,mCAAmC;IACnC,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".signup {\n    background-color: #ffffff;\n    position: relative;\n    height: 100%;\n    background-image: url(\"../../assets/images/login-drop.svg\");\n    background-repeat: no-repeat;\n    background-position: -120px 20px;\n    background-size: 400px;\n    position: relative;\n}\n\n.signup .container {\n    max-width: 100%;\n    background-image: url(\"../../assets/images/Mask\\ Group\\ 16@2x.png\");\n    background-repeat: no-repeat;\n    background-size: cover;\n    text-align: center;\n    padding: 30px 100px;\n}\n\n.signup-header h1 {\n    font-size: 20px;\n    color: #2A2F5C;\n    font-weight: 600;\n}\n\n.signup .home {\n    position: absolute;\n    top: 30px;\n    left: 20px;\n    border-bottom: 2px solid #060D27;\n}\n\n.signup .home a{\n    color: #060D27;\n    text-decoration: none;\n}\n\n.signup-section {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: #ffffff;\n    box-shadow: 0px 20px 50px #00000029;\n    border-radius: 20px;\n    padding: 20px 0px 0px 0px;\n}\n\n.signup .form-data {\n    width: 600px;\n}\n\n.signup .form-label {\n    text-align: left;\n    color: #5E6C9A;\n    font-weight: 600;\n}\n\n.signup .form-control {\n    background-color: transparent;\n    border: 1px solid #3E6BFF;\n    border-radius: 8px;\n    color: #A0A0A0;\n    box-shadow: none;\n}\n\n.signup .error {\n    border: 1px solid #E86880;\n}\n\n.signup .form h2{\n    letter-spacing: 0px;\n    color: #3C68F8;\n    font-size: 22px;\n}\n\n.signup .form p{\n    font-size: 14px;\n    letter-spacing: 0px;\n    color: #A0A0A0;\n}\n\n.signup .form a {\n    text-decoration: none;\n    color: #3C68F8;\n    font-weight: 100;\n}\n\n.signup .form span a {\n    color: #060D27;\n    font-weight: 600;\n}\n\n.signup small {\n    color: #E86880;\n}\n\n.signup .btn {\n    background-color: #060D27;\n    margin-top: 20px;\n    color: #ffffff;\n    font-weight: 600;\n    border-radius: 30px;\n    width: 50%;\n    height: 45px;\n    margin-bottom: 20px;\n}\n\n.signup .welcome-vid {\n    position: absolute;\n    z-index: 0;\n    top: 0;\n    right: 150px;\n    margin-top: 5px;\n}\n\n.signup .welcome-vid video{\n    height: 300px;\n}\n\n.signup .form-data .password {\n    position: relative;\n}\n\n.signup .form-data .password img {\n    position: absolute;\n    top: 42px;\n    right: 10px;\n    height: 12px;\n    margin-right: 15px;\n    cursor: pointer;\n}\n\n.signup .password input {\n    letter-spacing: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
